import React from 'react'
import { Box, Typography } from '@mui/material'
import { PLACEHOLDER_MIN_HEIGHT, PLACEHOLDER_MAX_WIDTH } from '../Config/layoutConstants'

interface PlaceholderTextProps {
  text?: string
}

export const PlaceholderText: React.FC<PlaceholderTextProps> = ({
  text = 'Query titles via the form accessible via the hamburger menu.',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: (theme) => theme.spacing(PLACEHOLDER_MIN_HEIGHT),
        padding: 3,
      }}
    >
      <Typography
        variant="subtitle1"
        color="text.secondary"
        sx={{
          textAlign: 'center',
          maxWidth: (theme) => theme.spacing(PLACEHOLDER_MAX_WIDTH),
        }}
      >
        {text}
      </Typography>
    </Box>
  )
}

export default PlaceholderText
